export default "__VITE_ASSET__CMFTG6UJ__"